export default "__VITE_ASSET__BEhlhZ0K__"